/* Sunny Road 2025 */

/* Chelsea and Rachel Co. 2025 */

Object.defineProperty(String.prototype, "capitalize", {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});
Object.defineProperty(String.prototype, "depluralize", {
  value: function () {
    let lastChar = this.substring(this.length - 1);
    if (lastChar == "s" || lastChar == "S") {
      return this.substring(0, this.length - 1);
    }
    return this;
  },
  enumerable: false,
});

class SrDVariableStore {
  static setValues(textObject) {
    if (window._SrDVariableStoreValues) {
      window._SrDVariableStoreValues = {
        ...window._SrDVariableStoreValues,
        ...textObject,
      };
    } else {
      window._SrDVariableStoreValues = textObject;
    }
  }
  static intFor(key, defaultValue) {
    return parseInt(SrDVariableStore.textFor(key, defaultValue));
  }
  static textFor(key, defaultValue) {
    if (window._SrDVariableStoreValues[key]) {
      return window._SrDVariableStoreValues[key];
    } else {
      if (defaultValue) {
        return defaultValue;
      } else {
        return `missing text for ${key}`;
      }
    }
  }
  static multilineTextFor(key, tag = "p", attributes = {}) {
    let attributesString = Object.entries(attributes)
      .map((values) => `${values[0]}="${values[1]}"`)
      .join(" ");
    return SrDVariableStore.textFor(key, "")
      .split("\n")
      .map((line) => `<${tag} ${attributesString}>${line}</${tag}`)
      .join("\n");
  }
}

class HasUUID {
  contructor(options) {
    this.uuid = crypto.randomUUID();
  }
  getThisElement() {
    return document.querySelector(`[data-uuid="${this.uuid}"]`);
  }
}

class SrD {
  api_version = "2024-10";
  keyname = "subscriptions-2024-02";
  constructor(opts = {}) {
    this.config = { ...this.defaults(), ...opts };
    this.errors = [];
    this.requires().forEach((field) => {
      if (!field in this.config) {
        this.errors.push(`Missing Required config field: ${field}`);
      }
    });
    if (this.errors.length > 0) {
      throw new Error(this.errors.join("\n"));
    }
    this.observers = {};
  }
  static dispatchEvent(name, detail = null) {
    document.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail: detail })
    );
  }
  static scrollToTarget(selector) {
    var element = document.querySelector(selector);
    var headerOffset = 0;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  requires() {
    return [];
  }
  defaults() {
    return {
      api_version: "2023-10",
      keyname: "subscriptions-2024-02",
      siteRoot: "",
    };
  }
  fetch(url, config) {
    if (this.config.fetch_function) {
      return pure_fetch(url, config);
    } else {
      return fetch(url, config);
    }
  }
  /* shopify cart functions */
  siteUrl(path) {
    if (this.config.siteRoot) {
      return `${this.config.siteRoot}${path}`;
    }
    return path;
  }
  async getCart(
    url = this.siteUrl("/cart.js"),
    extended = false,
    callback = () => {}
  ) {
    let cart = {};
    return this.fetch(url).then((res) => (extended ? res.text() : res.json()));
  }
  async request(url) {
    return this.fetch(this.siteUrl(ur)).then((text) => response.text());
  }
  async updateCart(payload) {
    return this.fetch(this.siteUrl(`/cart/update.js`), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      body: JSON.stringify(payload),
    }).then((response) => response.json());
  }
  async removeItemFromCart(key) {
    return this.changeCart({
      id: key,
      quantity: 0,
    });
  }
  async updateItemCount(key, quantity) {
    return this.changeCart({
      id: key,
      quantity: parseInt(quantity),
    });
  }
  async changeCart(payload) {
    return this.fetch(this.siteUrl(`/cart/change.js`), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      body: JSON.stringify(payload),
    }).then((response) => response.json());
  }
  async addToCart(payload) {
    let config = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    };
    return this.fetch(this.siteUrl("/cart/add.js"), config).then((response) =>
      response.json()
    );
  }

  static setupDawnProductForm(form) {
    form.querySelector("button").addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      new SrD().addToDawnCart(form).then((response) => {});
    });
  }
  async addToDawnCart(form) {
    let cart = document.querySelector("cart-drawer");
    const formData = new FormData();
    formData.append("product-id", form.dataset.productId);
    formData.append("id", form.querySelector('[name="id"]').value);
    formData.append("quantity", 1);
    try {
      formData.append(
        "selling_plan",
        form.querySelector('[name="selling_plan"]').value
      );
    } catch (e) {}

    formData.append(
      "sections",
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", form.dataset.url);
    formData.append("form_type", "product");

    return this.fetch(this.siteUrl("/cart/add"), {
      method: "POST",
      headers: {
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
      form,
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.status) {
          SrDModal.show(json.description);
        } else {
          cart.renderContents(json);
          cart.classList.remove("is-empty");
        }
        return json;
      });
  }

  /* graphql functions */
  async graphql(query, params) {
    return fetch(this.siteUrl(`/api/${this.api_version}/graphql.json`), {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.config.graphql_token,
      },
      body: JSON.stringify({ query: query, variables: params }),
    }).then((response) => response.json());
  }
  graphql_sync(query, params) {
    let ajax = new XMLHttpRequest();
    ajax.headers = {
      "content-type": "application/json",
      "X-Shopify-Storefront-Access-Token": this.config.graphql_token,
    };
    ajax.open(
      "POST",
      this.siteUrl(`/api/${this.api_version}/graphql.json`),
      false
    );
    ajax.setRequestHeader("Content-Type", "application/json");
    ajax.setRequestHeader(
      "X-Shopify-Storefront-Access-Token",
      storefront_token
    );
    ajax.send(JSON.stringify({ query: query, params: params }));
    return JSON.parse(ajax.responseText);
  }
  gid2id(gid) {
    return parseInt(gid.split("/").pop());
  }
  collapse_query(object) {
    if (object == null) {
      return object;
    }
    switch (object.constructor.name) {
      case "Array":
        return object.map((item) => this.collapse_query(item));
        break;
      case "Object":
        let ret = {};
        Object.keys(object).forEach((key) => {
          if (object[key] == null) {
            ret[key] = null;
            return;
          }
          if (object[key].reference) {
            ret[key] = this.collapse_query(object[key].reference);
            return;
          }
          if (object[key].references) {
            let all = [];
            object[key].references.nodes.forEach((ref) => {
              let crv = {};
              if (ref.fields) {
                ref.fields.forEach((field) => {
                  crv[field.key] = this.collapse_query(field.value);
                });
              } else {
                Object.keys(ref).forEach((field) => {
                  if (ref[field]) {
                    if (ref[field].value) {
                      crv[field] = this.collapse_query(ref[field].value);
                    } else {
                      let newHash = {};
                      Object.keys(ref[field]).forEach((key) => {
                        newHash[key] = this.collapse_query(ref[field][key]);
                      });
                      crv[field] = newHash;
                    }
                  } else {
                    crv[field] = null;
                  }
                });
              }

              all.push(crv);
            });
            object[key] = all;
          }
          if (object[key].type && object[key].type == "json") {
            object[key] = JSON.parse(object[key]);
          }
          if (
            object[key].nodes &&
            object[key].nodes.constructor.name == "Array"
          ) {
            ret[key] = this.collapse_query(object[key].nodes);
          } else {
            ret[key] = this.collapse_query(object[key]);
          }
        });
        return ret;
        break;
      default:
        if (object) {
          return object;
        }

        break;
    }
  }
  css() {
    return "";
  }
  inject_css() {
    let css = this.css();
    if (css.length > 0) {
      let style = document.createElement("style");
      style.id = this.constructor.name.toLowerCase();
      style.textContent = this.css();
      document.querySelector("head").appendChild(style);
    }
  }
  slugify(str) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str
      .replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
      .replace(/\s+/g, "-") // replace spaces with hyphens
      .replace(/-+/g, "-"); // remove consecutive hyphens
    return str;
  }
  unmonitoredAction(form, field, action) {
    if (!this.observers) {
      action();
      return;
    }
    console.error(this.observers);
    console.error("starting unmonitored action");
    if (this.observers[field]) {
      if (this.observers[field] != "true") {
        this.observers[field].disconnect();
        delete this.observers[field];
      }
    }
    action();
    console.error("ending unmonitored action");
    this.monitorForm(form, field);
  }
  monitorForm(form) {
    if (!this.observers) {
      this.observers = {};
    }
    Array.from(arguments).forEach((argument, index) => {
      if (index == 0) {
        return;
      }
      let field = form.querySelector(`[name="${argument}"]`);
      if (this.observers[argument]) {
        return;
      }
      let key = `data-monitoring-${argument}`;
      if (form.getAttribute(key)) {
        return;
      }
      switch (field.tagName) {
        case "SELECT":
          this.observers[argument] = "true";
          field.addEventListener("change", (event) => {
            if (window._form_montor_on) {
              SrD.dispatchEvent("srd:formValue:changed", {
                field: argument,
                value: field.options[field.selectedIndex].value,
              });
            }
          });
          break;
        default:
          this.observers[argument] = new MutationObserver((list, observer) => {
            SrD.dispatchEvent("srd:formValue:changed", {
              field: argument,
              value: field.value,
            });
          });
          this.observers[argument].observe(field, {
            attributes: true,
            subtree: false,
            childList: false,
          });
      }
    });
  }
}

class SrDStorefront extends SrD {
  requires() {
    return ["graphql_token"];
  }
}
/* src/srd-quantity-field/srd-quantity.js  */
class SrDQuantity {
  defaults() {
    return {
      min: 1,
      max: 999999,
      step: 1,
      value: 1,
      dataset: {},
    };
  }
  constructor(options = {}) {
    this.uuid = crypto.randomUUID();
    this.config = { ...this.defaults(), ...options };
  }
  dataset() {
    return Object.keys(this.config.dataset)
      .map((k) => `data-${k}="${this.config.dataset[k]}"`)
      .join(" ");
  }
  setdata(data) {
    this.config.dataset = {};
  }
  render() {
    return `
        <div class="srd-quantity ${
          this.config.value > 0 ? "active" : ""
        }" data-uuid="${this.uuid}">
            <div class="wrapper">
                <span class="minus" data-uuid="${this.uuid}">-</span>
                <label for="${this.uuid}">${this.config.value}</label>
                <input type="number" name="quantity" class="quantity-input" min=${
                  this.config.min
                }" max="${this.config.max}" step="${this.config.step}" value="${
      this.config.value
    }" id="${this.uuid}" ${this.dataset()}/>
                <span class="plus" data-uuid="${this.uuid}">+</span>
            </div>
            <span class="extra">${this.extra()}</span>
        </div>
        `;
  }
  root() {
    return document.querySelector(`[data-uuid="${this.uuid}"]`);
  }
  static setupEvents() {
    document.querySelectorAll(".srd-quantity").forEach((quantity) => {
      let current = quantity.querySelector(".quantity-input");
      let label = quantity.querySelector("label");
      quantity.querySelector(".plus").addEventListener("click", (event) => {
        if (current.disabled) {
          return;
        }
        if (parseInt(current.value) + 1 <= parseInt(current.max)) {
          current.value = parseInt(current.value) + 1;
          label.textContent = current.value;

          quantity.classList.add("active");
          this.active = true;
          let dataset = Object.assign({}, current.dataset);
          dataset.quantity = current.value;
          SrD.dispatchEvent("srd:quantity:changed", {
            dataset: dataset,
            value: current.value,
            field: current,
          });
        }
      });
      quantity.querySelector(".minus").addEventListener("click", (event) => {
        if (current.disabled) {
          return;
        }
        if (parseInt(current.value) - 1 >= parseInt(current.min)) {
          current.value = parseInt(current.value) - 1;
          label.textContent = current.value;
          if (current.value <= parseInt(current.min)) {
            quantity.classList.remove("active");
          }
          this.active = true;
          let dataset = Object.assign({}, current.dataset);
          dataset.quantity = current.value;
          SrD.dispatchEvent("srd:quantity:changed", {
            dataset: dataset,
            value: current.value,
            field: current,
          });
        }
      });
    });
  }
  extra() {
    return "";
  }
}

class SrDOptionsHandler {
  constructor(productOptions, variants) {
    [];
    this.optionsMap = {};
    this.variantsMap = {};
    this.options = productOptions.map((option) => {
      return {
        name: option.name,
        values: option.values.map((value) => value.value),
      };
    });
    variants.forEach((variant) => {
      let key = variant.options.map((option) => option.value).join("|");
      this.optionsMap[key] = {
        values: variant.options.map((option) => option.value),
        variantId: variant.id.split("/").pop(),
        available: variant.available,
        price: parseFloat(variant.price.amount),
      };
    });
  }

  allOptionsMap(options, index) {}

  optionNames() {
    return Object.keys(this.options);
  }
  getVariant(options) {
    return this.optionsMap[options.join("|")];
  }
}

/* src/srd-sticky/sticky.js  */
class SrDSticky extends SrD {
  defaults() {
    return {
      targetBottomOffset: 0,
      stickySpacing: 5,
      stickTo: "bottom",
    };
  }
  constructor(options) {
    super(options);
    this.sticky = document.querySelector(this.config.sticky);
    this.target = document.querySelector(this.config.target);
    this.mode = this.config.mode;
    if (this.mode == "MOBILE_ONLY" && window.innerWidth <= 763) {
      return;
    } else if (this.mode == "DESKTOP_ONLY" && window.innerWidth >= 762) {
      return;
    }

    this.reposition();
    if (window.innerWidth <= 762) {
      this.sticky.classList.remove("ignore-default-behaviour");
    }

    document.addEventListener("scroll", (event) => {
      this.handleScrollV2(event);
    });
  }
  reposition() {
    let stickyBounds = this.sticky.getBoundingClientRect();
    document.querySelector(
      "mobile-dock"
    ).style.bottom = `${stickyBounds.height}px`;
  }
  stickyOffset(spacing = null) {
    if (spacing == null) {
      spacing = this.config.stickySpacing;
    }
    let stickyBounds = this.sticky.getBoundingClientRect();

    switch (this.config.stickTo) {
      case "bottom":
        return (
          window.pageYOffset +
          window.innerHeight -
          (stickyBounds.height + spacing)
        );
        break;
      case "top":
        return window.pageYOffset + spacing;
        break;
    }
  }

  handleScrollV2(event) {
    let targetBounds = this.target.getBoundingClientRect();
    let stickyTopOffset = this.stickyOffset();

    let sticky = document.querySelector("mobile-dock.pdp-atc");

    if (
      targetBounds.top <=
      (targetBounds.height + this.config.targetBottomOffset) * -1
    ) {
      document.querySelector(".sticky-holder").classList.add("is-active");
      sticky.classList.add("is-active");
      SrD.dispatchEvent("srd:status:actived", null);
    } else {
      sticky.classList.remove("is-active");
      SrD.dispatchEvent("srd:status:deactived", null);
    }
  }
}
/* src/srd-rendered-sticky/rendered-atc.js  */
class SrdRenderedSticky extends SrDSticky {
  constructor(options) {
    super(options);
    this.form = document.querySelector(this.config.form_selector);
    this.myForm = document.querySelector(".pdp-sticky-form");
    this.variantId = this.config.variantId;

    this.loadData();
  }

  loadData() {
    this.graphql(
      `
        query getProductData($id:ID!) {
          product(id:$id) {
            id
            title
            options(first: 3) {
                name
                values: optionValues {
                  value: name
                }
            }
            featuredImage {
              alt: altText
              src: url
            }
            ${this.additionalProductQuery()}
            variants(first:50) {
                nodes {
                  id
                  title
                  available: availableForSale
                  image {
                    alt: altText
                    src: url
                  }
                  price {
                    amount
                  }
                  options: selectedOptions {
                    name
                    value
                  }
                  ${this.additionalVariantQuery()}
                }
              }
            }
          }
        
        `,
      { id: `gid://shopify/Product/${this.config.productId}` }
    ).then((q) => {
      console.error(q);
      this.init(q.data.product);
    });
  }
  additionalProductQuery() {
    return "";
  }
  additionalVariantQuantity() {
    return "";
  }

  init(product) {
    let variantBuilder = (variant) => {
      let key = variant.id.split("/").pop();
      let newObject = {};
      newObject[key] = variant;
      return newObject;
    };

    this.optionsHandler = new SrDOptionsHandler(
      product.options,
      product.variants.nodes
    );
    this.variants = product.variants.nodes.reduce(
      (a, b) => Object.assign(a, variantBuilder(b)),
      {}
    );
    this.selectedVariant = this.variants[this.variantId];
    this.quantity = this.form.querySelector('[name="quantity"]').value;
    this.product = product;
    this.monitorForm(this.form, "id", "quantity");

    document.addEventListener("srd:formValue:changed", (event) => {
      switch (event.detail.field) {
        case "id":
          this.selectedVariant = this.variants[event.detail.value];
          break;
        case "quantity":
          this.quantity = event.detail.value;
          break;
      }

      this.render();
    });
    document.addEventListener("srd:quantity:changed", (event) => {
      this.quantity = event.detail.value;
      this.unmonitoredAction(() => {
        this.form.querySelector('[name="quantity"]').value = event.detail.value;
      });
    });
    this.render();
  }
  render() {}
  currentPrice() {
    let amount = this.selectedVariant.price.amount;
    let amountAsDecimal = parseFloat(amount);
    if (amountAsDecimal % 1 > 0) {
      return amount;
    } else {
      return amount.split(".")[0];
    }
  }
  currentVariantOption(optionName) {
    return this.selectedVariant.options.find(
      (option) => option.name == optionName
    ).value;
  }
  render() {}

  setupEvents() {}
}

/* src/srd-rendered-sticky/markethouse/markethouse.js  */
class MarketHouseSticky extends SrdRenderedSticky {
  constructor(options) {
    super(options);
  }

  additionalProductQuery() {
    return `
      `;
  }
  additionalVariantQuery() {
    return `
      `;
  }
  render() {
    let innerHtml = `
        
          <input type="hidden" name="id" value="${
            this.selectedVariant ? this.gid2id(this.selectedVariant.id) : ""
          }">
          <input type="hidden" name="quantity" value="${this.quantity}">
          <div class="product-info">
            <div class="product-image">
              <img src="${this.product.featuredImage.src}">
            </div>
            <div class="product-description">
              <div class="product-name">${this.product.title}</div>
              <div class="product-price">$${this.currentPrice()}</div>
            </div>
          </div>
          <div class="dummy"></div>
          <div class="pdp-sticky-atc">
            ${this.optionsHandler.options
              .map(
                (option) => `
            <div class="pdp-sticky-select-holder">
              <select class="sticky-pdp-select" name="${option.name}">
              ${option.values
                .map(
                  (value) =>
                    `<option value="${value}" ${
                      value == this.currentVariantOption(option.name)
                        ? " selected"
                        : ""
                    }>${value}</option>`
                )
                .join("\n")}
              </select>
            </div>
          
          
          `
              )
              .join("\n")}
            
            <div class="atc-button">
            
              ${this.renderATC()}
              
            </div>
          </div>
          
        
      `;
    this.sticky.innerHTML = innerHtml;
    this.reposition();
    this.setupEvents();
  }
  renderATC() {
    if (!this.selectedVariant || !this.selectedVariant.available) {
      return `<button name="atc" class=" cta button text-uppercase sticky-atc" disabled>Sold Out</button>`;
    } else {
      return `<button name="atc" class=" cta button text-uppercase sticky-atc">Add to cart</button>`;
    }
  }
  setupEvents() {
    this.myForm.querySelectorAll("select").forEach((select) =>
      select.addEventListener("change", (event) => {
        let selectValue = select.options[select.selectedIndex].value;
        let variant = this.optionsHandler.getVariant(
          Array.from(this.myForm.querySelectorAll("select")).map(
            (select) => select.options[select.selectedIndex].value
          )
        );

        this.variantId = variant.variantId;
        this.selectedVariant = this.variants[this.variantId];

        let variantSelects = document.querySelector(`variant-radios`);
        let field = variantSelects.querySelector(
          `input[name="${select.name}"][value="${selectValue}"]`
        );
        field.click();
        this.render();
      })
    );

    document
      .querySelector(".srd-sticky.pdp-atc .sticky-atc")
      .addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.form.querySelector('[name="add"]').click();
      });
  }
}
